import React from 'react';
import {
  Box,
  Carousel,
  Text,
  Accordion,
  useScreenSize,
} from '@stitch-fix/mode-react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import { MatchingItemProductCard } from './MatchingItemProductCard';

export const MatchingSetCarousel = () => {
  const screenSize = useScreenSize();
  const [state] = useProductDetailsPageContext();
  const matchingItems = state.matchingSet?.matchingSet;

  const { ref, EventProvider } = useViewEvent({
    schema: 'view',
    content_id: 'matching_set',
    name: 'carousel',
  });

  if (!matchingItems?.length) return null;

  return (
    <EventProvider>
      <Box
        ref={ref}
        style={{
          overflowX: ['md', 'sm'].includes(screenSize) ? 'visible' : 'auto',
        }}
      >
        <Accordion
          heading={
            <Text setting="title-small">{state.matchingSet?.title}</Text>
          }
          headingLevel="h2"
          expandIconAlignment="fixed-end"
          my={{ sm: 1.5, md: 2 }}
          defaultIsExpanded
        >
          <Box
            style={{
              overflow: ['md', 'sm'].includes(screenSize) ? '' : 'hidden',
            }}
          >
            <Box pb={{ sm: 1, md: 1.5 }}>
              <Text mt={1} setting="body-medium">
                {state.matchingSet?.description}
              </Text>
            </Box>
            <Box
              style={{ position: 'relative', overflow: 'visible' }}
              width="100%"
              maxWidth="100%"
            >
              <Carousel
                slideWidth={{ sm: '182px', md: '244px' }}
                gutterOverflow={{ sm: 1, lg: 0, xl: 0 }}
                ariaLabel="Matching set"
              >
                {matchingItems.map((item, index) => (
                  <MatchingItemProductCard
                    key={item?.variant?.sku || index}
                    item={item}
                    index={index}
                  />
                ))}
              </Carousel>
            </Box>
          </Box>
        </Accordion>
      </Box>
    </EventProvider>
  );
};
